import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useEditEventSeriesContext } from '../EditEventSeriesProvider'

import { formatEventSubheadlineLocation } from 'utils/helpers'

import { ClockIcon, PinIcon } from 'images'

export default function EventItem(props) {
  const { event, isIncluded, isSelecting } = props
  const { t, i18n } = useTranslation()
  const {
    toggleEventSelection,
    addEventToIncluded,
    removeEventFromIncluded,
    selectedEvents,
  } = useEditEventSeriesContext()

  const isSelected = selectedEvents.has(event.id)

  const currentLanguage = i18n.language
  const btnClassName = `${currentLanguage === 'de' ? 'event-item_action-button_de-btn' : 'event-item_action-button_en-btn'}`

  const handleToggle = (e) => {
    e.stopPropagation()
    toggleEventSelection(event.id)
  }

  const handleAddClick = (e) => {
    e.stopPropagation()
    addEventToIncluded(event.id)
  }

  const handleRemoveClick = (e) => {
    e.stopPropagation()
    removeEventFromIncluded(event.id)
  }
  
  return (
    <>
      <div className='event-item_wrapper'>
        <div className='event-item_left-content'>
          {isSelecting && !isIncluded ? (
            <div className="event-item_custom-checkbox-wrapper">
              <label 
                data-cy={`event-${event.id}-checkbox`} 
                className="event-item_custom-checkbox"
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={handleToggle}
                />
                <span></span>
              </label>
            </div>
          ) : (
            <div className="event-item_left-content_img">
              <i className="icon-events" />
            </div>
          )}

          <div className="event-item_title-and-date_wrapper">
            <div className="event-item_title-and-date_title">{event.title}</div>

            <div className="event-item_title-and-date_date_wrapper">
              <span className="event-item_title-and-date_date_time">
                <ClockIcon className="mr-1" height={12} width={17} />

                <time dateTime={moment.utc(event.start_date_time).format('DD.MM.YYYY, HH:mm')}>
                  {moment.utc(event.start_date_time).format('DD.MM.YYYY, HH:mm')}
                </time>
              </span>

              <span className="event-item_title-and-date_date_location">
                <PinIcon className="mr-1" height={12} width={17} />

                <span>
                  {formatEventSubheadlineLocation({
                    city: event.city,
                  })}
                </span>
              </span>
            </div>
          </div>
        </div>

        {isIncluded ? (
          <button 
            className={`event-item_action-button ${btnClassName}`}
            onClick={handleRemoveClick}
          >
            {t('Event.editEventSeriesModal.remove')}
          </button>
        ) : (
          <button 
            className={`event-item_action-button ${btnClassName}`}
            onClick={handleAddClick}
          >
            {t('Event.editEventSeriesModal.add')}
          </button>
        )}
      </div>
    </>
  )
}

EventItem.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    city: PropTypes.string,
    title: PropTypes.string,
    date: PropTypes.string,
  }).isRequired,
  isIncluded: PropTypes.bool,
  isSelecting: PropTypes.bool,
}
